import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  background-color: #fff;
  justify-content: flex-start;
  @media (min-width: 1280px) {
    justify-content: center;
  }
`;

export const Layout = styled.div`
  display: flex;
  gap: 8px 4px;
  flex-wrap: wrap;
  padding: 18px 16px;
  width: calc(100vw - 32px);
  text-transform: capitalize;
  @media (min-width: 768px) {
    width: calc(100vw - 64px);
    padding: 20px 32px;
    flex-wrap: nowrap;
  }
  @media (min-width: 1280px) {
    width: 1040px;
    justify-content: flex-start;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  gap: 4px;
  color: rgba(60, 60, 59, 0.8);
  /* Body 2/Regular */
  font-family: 'DM-Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.25px;
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  svg {
    height: 14px;
    width: 14px;
    :hover {
      cursor: auto;
    }
  }
  a {
    color: rgba(60, 60, 59, 0.5);
    white-space: nowrap;
    text-decoration-line: underline;
  }

  a:hover {
    text-decoration-color: rgba(60, 60, 59, 0.5);
  }

  @media screen and (min-width: 768px) {
    flex-wrap: nowrap;
  }
  @media screen and (min-width: 1280px) {
    font-size: 16px;
    letter-spacing: 0.5px;
    flex-wrap: nowrap;
    svg {
      height: 18px;
      width: 18px;
    }
  }
`;
